export class AssistantConst {
  static readonly APP_FILTER_NAME: string = 'app';
  static readonly ACCOUNT_FILTER_NAME: string = 'account';
  static readonly TYPE_FILTER_NAME: string = 'type';
  static readonly MORE_FILTERS_FILTER_NAME: string = 'more-filters';
  static readonly SPECIAL_FILTER_NAME = 'specialFilter';
  static readonly SPECIAL_FILTER_TITLE = 'Specific resource';
}
